var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      class: [
        _vm.$style["mds-tabs"],
        _vm.classObject,
        _vm.responsiveObject,
        _vm.variationClass,
        _vm.sizeClass,
      ],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "ul",
        {
          ref: "container",
          class: _vm.$style["mds-tabs__inner"],
          attrs: { role: "tablist" },
        },
        [
          _vm._t("default", function () {
            return _vm._l(_vm.content, function (item, index) {
              return _c(
                "mds-tabs-item",
                _vm._b(
                  {
                    key: index,
                    attrs: { onDark: _vm.onDark, size: _vm.size },
                    on: {
                      "mds-tabs-item-active": function ($event) {
                        return _vm.$emit("mds-tabs-item-active", $event)
                      },
                    },
                  },
                  "mds-tabs-item",
                  item,
                  false
                )
              )
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }